import Commons from '../../../../Services/Common/Common';

export const M_PER_CUSTOM_Schema = {
  mapper: {
    search1: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      WorkDate: (context) => Commons.EncryptAES(context.search?.startDate),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      DepCd: (context) => Commons.EncryptAES(context.search?.depCd),
      UserId: (context) => context.userInfo?.userid,
      SearchText: () => Commons.EncryptAES(''),
    },
    search2: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search3: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search4: {
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      WorkEndDate: (context) => context.workEndDate,
      UserId: (context) => context.userInfo?.userid,
      SmId: (context) => Commons.EncryptAES(context.smId),
    },
    save2: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      DepHeadId: (context) => Commons.EncryptAES(context.currentHead?.headId),
      DepSignPath: (context) => Commons.EncryptAES(''),
    },
  },
};
